import styled from '@emotion/styled';
import React from 'react';

type Props = {
  isInverted?: boolean;
  color?: string;
};

export const WaveRule = ({ isInverted = false, color = '#8940fa' }) => (
  <Wave isInverted={isInverted} color={color} />
);

const Wave = styled.div<Props>`
  background-image: url('https://d12xoj7p9moygp.cloudfront.net/images/homepage/wave.svg');
  background-color: ${({ color }: Props) => color};
  height: 24px;
  transform: ${({ isInverted }: Props) => (isInverted ? 'rotate(180deg)' : '')};
  @media (max-width: 1024px) {
    height: 18px;
    background-size: contain;
  }
  @media (max-width: 420px) {
    height: 14px;
  }
`;
